import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ListaCategorias = ({ onSelectCategoria }) => {
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    fetchCategorias();
  }, []);

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${API}/categorias`);
      setCategorias(response.data);
    } catch (error) {
      console.error('Error al obtener categorías:', error);
    }
  };

  return (
    <div className="grid">
      {categorias.map((cat) => (
        <div key={cat.id} className="card">
          <h3>⚽ Categoría {cat.año}</h3>
          <button 
            className="primary" 
            onClick={() => onSelectCategoria(cat.año)}
            data-testid={`categoria-${cat.año}-btn`}
          >
            Ingresar
          </button>
        </div>
      ))}
    </div>
  );
};

export default ListaCategorias;